// Import Configs
import '../config/form/form';

// Import Commons
import '../common/auth/auth';
import '../common/data/data';
import '../common/data/reader/ticketReader';
import '../common/featureFlags';
import '../common/tracking/sentry';
import '../common/user/user';

// Core ui components
import '../common/ui/acceptableAccordion/acceptableAccordion';
import '../common/ui/actionTabs/actionTabs';
import '../common/ui/address/address';
import '../common/ui/affix/affix';
import '../common/ui/appHeader/appHeader';
import '../common/ui/box/box';
import '../common/ui/breadcrumb/breadcrumb';
import '../common/ui/chart/chart';
import '../common/ui/descriptiveBox/descriptiveBox';
import '../common/ui/errorHandling/errorHandling';
import '../common/ui/financeBulkImport/financeBulkImport';
import '../common/ui/form/buttons/formButtons';
import '../common/ui/form/validation/formValidation';
import '../common/ui/faq/faq';
import '../common/ui/head/head';
import '../common/ui/iframeFix/iframeFix';
import '../common/ui/infoBox/infoBox';
import '../common/ui/infoIcon/infoIcon';
import '../common/ui/inputForm/inputForm';
import '../common/ui/isBrowser/isBrowser';
import '../common/ui/languageSwitcher/languageSwitcher';
import '../common/ui/needsConfirmation/needsConfirmation';
import '../common/ui/notification/notification';
import '../common/ui/passwordRequirementsCheck/passwordRequirementsCheck';
import '../common/ui/pdfViewer/pdfViewer';
import '../common/ui/radioAccordion/radioAccordion';
import '../common/ui/router/router';
import '../common/ui/twoFactorModal/twoFactorModal';

// Import the components that make up the main subsections of the application
// Each submodule registers its own states/services/components
import '../app';
import '../components/customerConfirm/customerConfirm';
import '../components/customerEntry/customerEntry';
import '../components/home/home';
import '../components/error/error';
import '../components/forgotPassword/forgotPassword';
import '../components/inbox/inbox';
import '../components/login/login';
import '../components/loginByToken/loginByToken';
import '../components/notFound/notFound';
import '../components/public/public';
import '../components/resetPassword/resetPassword';
import '../components/zkgDocuments/zkgDocuments';
import '../components/bankInfo/bankInfo';
import '../components/ticketError/ticketError';
import '../components/tickets/tickets';

// The admin view to view and edit users
import '../components/admin/admin';

// Ticket views
import '../components/ticket/ticket';
import '../components/ticket/states/authorization/authorization';
import '../components/ticket/states/authorizationReceiving/authorizationReceiving';
import '../components/ticket/states/upload/upload';
import '../components/ticket/states/standingOrders/standingOrders';
import '../components/ticket/states/finances/finances';
import '../components/ticket/states/confirm/confirm';
import '../components/ticket/states/select/select';
import '../components/ticket/states/waitForTransferring/waitForTransferring';
import '../components/ticket/states/downloadBalanceList/downloadBalanceList';
import '../components/ticket/states/completed/completed';
import '../components/ticket/states/closed/closed';
import '../components/ticket/states/dws/dws';

// Import application hooks
import '../hooks/hooks';
